<script>
import {appVersion} from "@utils/appVersion";

export default {
  computed: {
    visible() {
      return appVersion.stale;
    },
  },
  methods: {
    reload() {
      window.location.reload();
    },
  },
};
</script>

<template>
  <div
    role="status"
    aria-live="polite"
    class="tw-fixed tw-inset-x-0 tw-bottom-5 tw-z-[1100] tw-flex tw-justify-center tw-px-4 tw-pointer-events-none"
  >
    <transition
      enter-active-class="tw-transition tw-duration-300 tw-ease-out"
      enter-class="tw-opacity-0 tw-translate-y-3"
    >
      <div
        v-if="visible"
        data-testid="new-version-pill"
        class="tw-pointer-events-auto tw-flex tw-items-center tw-gap-4 tw-rounded-full tw-bg-primary tw-py-2.5 tw-pl-6 tw-pr-4 tw-text-white tw-shadow-lg"
      >
        <div class="tw-flex tw-items-center tw-gap-2.5">
          <i class="fe-refresh-cw tw-shrink-0 tw-text-lg" />
          <span class="tw-text-sm tw-font-semibold tw-leading-snug">{{ $t('newVersion.title') }}</span>
        </div>
        <button
          type="button"
          data-testid="new-version-reload"
          class="tw-shrink-0 tw-rounded-full tw-border-0 tw-bg-white tw-px-4 tw-py-1.5 tw-text-sm tw-font-bold tw-text-primary tw-ring-2 tw-ring-transparent tw-transition hover:tw-ring-white/50"
          @click="reload"
        >
          {{ $t('newVersion.reload') }}
        </button>
      </div>
    </transition>
  </div>
</template>
